__turbopack_context__.v({
  "buttons": "CoreButtons-module-scss-module__CVFT8q__buttons",
  "flexWrap-nowrap": "CoreButtons-module-scss-module__CVFT8q__flexWrap-nowrap",
  "flexWrap-wrap": "CoreButtons-module-scss-module__CVFT8q__flexWrap-wrap",
  "justifyContent-center": "CoreButtons-module-scss-module__CVFT8q__justifyContent-center",
  "justifyContent-left": "CoreButtons-module-scss-module__CVFT8q__justifyContent-left",
  "justifyContent-right": "CoreButtons-module-scss-module__CVFT8q__justifyContent-right",
  "justifyContent-space-between": "CoreButtons-module-scss-module__CVFT8q__justifyContent-space-between",
  "orientation-horizantal": "CoreButtons-module-scss-module__CVFT8q__orientation-horizantal",
  "orientation-vertical": "CoreButtons-module-scss-module__CVFT8q__orientation-vertical",
  "verticalAlignment-bottom": "CoreButtons-module-scss-module__CVFT8q__verticalAlignment-bottom",
  "verticalAlignment-center": "CoreButtons-module-scss-module__CVFT8q__verticalAlignment-center",
  "verticalAlignment-stretch": "CoreButtons-module-scss-module__CVFT8q__verticalAlignment-stretch",
  "verticalAlignment-top": "CoreButtons-module-scss-module__CVFT8q__verticalAlignment-top",
});
